<template>
  <div class="modal">
    <button
      class="modal__close"
      @click="$eventHub.$emit('closeModal')"
    >
      X
    </button>
    <AppParagraph
      class="modal__title"
      :data="{
        content: 'Register to recive our investment criteria'
      }"
    />
    <FormTemplate class="contact-form">
      <FormCore
        slot="core"
        data-theme="default"
        :slots="['row-0', 'row-1', 'row-2', 'row-3', 'row-4', 'row-5', 'row-6']"
      >
        <FormRow
          slot="row-0"
          :slots="['title', 'industry']"
        >
          <FormInput
            slot="title"
            :type="form.title.type"
            :params="form.title"
          />

          <FormInput
            slot="industry"
            :type="form.industry.type"
            :params="form.industry"
          />
        </FormRow>

        <FormRow
          slot="row-1"
          :slots="['fname', 'country']"
        >
          <FormInput
            slot="fname"
            :type="form.fname.type"
            :params="form.fname"
          />

          <FormInput
            slot="country"
            :type="form.country.type"
            :params="form.country"
          />
        </FormRow>

        <FormRow
          slot="row-2"
          :slots="['lname', 'crevenue']"
        >
          <FormInput
            slot="lname"
            :type="form.lname.type"
            :params="form.lname"
          />

          <FormInput
            slot="crevenue"
            :type="form.crevenue.type"
            :params="form.crevenue"
          />
        </FormRow>

        <FormRow
          slot="row-3"
          :slots="['email', 'crequirement']"
        >
          <FormInput
            slot="email"
            :type="form.email.type"
            :params="form.email"
          />

          <FormInput
            slot="crequirement"
            :type="form.crequirement.type"
            :params="form.crequirement"
          />
        </FormRow>

        <FormRow
          class="row--triple"
          slot="row-4"
          :slots="['col', 'message']"
        >
          <div slot="col" class="form__row">
            <FormInput
              :type="form.phone.type"
              :params="form.phone"
            />
            <FormInput
              :type="form.company.type"
              :params="form.company"
            />
          </div>

          <FormInput
            slot="message"
            :type="form.message.type"
            :params="form.message"
          />
        </FormRow>

        <FormRow
          slot="row-5"
          :slots="['website', 'pitchdeck']"
        >
          <FormInput
            slot="website"
            :type="form.website.type"
            :params="form.website"
          />
          <FormInput
            slot="pitchdeck"
            :type="form.pitchdeck.type"
            :params="form.pitchdeck"
          />
        </FormRow>

        <FormRow
          slot="row-6"
          :slots="['privacy', 'submit']"
        >

          <FormInput
            slot="privacy"
            :type="form.privacy.type"
            :params="form.privacy"
          />

          <FormInput
            slot="submit"
            :type="form.submit.type"
            :params="form.submit"
          />
        </FormRow>
      </FormCore>
    </FormTemplate>
  </div>
</template>

<script>
import AppParagraph from './AppParagraph.vue';
import FormTemplate from './Form/index.vue';
import FormCore from './Form/FormCore/index.vue';
import FormRow from './Form/FormExtra/FormRow.vue';
import FormInput from './Form/FormInput/index.vue';

export default {
  name: 'modal',
  components: {
    AppParagraph,
    FormTemplate,
    FormCore,
    FormRow,
    FormInput,
  },
  data() {
    return {
      form: {
        title: {
          id: 'title',
          name: 'title',
          type: 'select',
          label: 'Title',
          choices: [
            {
              value: 'mr',
              selected: true,
              label: 'Mr',
            },
            {
              value: 'mrs',
              label: 'Mrs',
            },
          ],
          size: 50,
          required: true,
        },
        industry: {
          id: 'industry',
          name: 'industry',
          type: 'text',
          label: 'Industry',
          size: 50,
          required: true,
        },
        fname: {
          id: 'fname',
          name: 'fname',
          type: 'text',
          label: 'Name',
          autocomplete: 'given-name',
          size: 50,
          required: true,
        },
        country: {
          id: 'country',
          name: 'country',
          type: 'text',
          label: 'Country',
          autocomplete: 'country',
          size: 50,
          required: true,
        },
        lname: {
          id: 'lname',
          name: 'lname',
          type: 'text',
          label: 'Surname',
          autocomplete: 'family-name',
          size: 50,
          required: true,
        },
        crevenue: {
          id: 'crevenue',
          name: 'crevenue',
          type: 'text',
          label: 'Current<br>Revenue',
          size: 50,
          required: true,
        },
        email: {
          id: 'email',
          name: 'email',
          type: 'email',
          label: 'Email',
          autocomplete: 'email',
          size: 50,
          required: true,
        },
        crequirement: {
          id: 'crequirement',
          name: 'crequirement',
          type: 'select',
          label: 'Capital Requirement',
          choices: [
            {
              value: 'USD 0 – 5M',
              selected: true,
              label: 'USD 0 – 5M',
            },
            {
              value: 'USD 5M – 10M',
              label: 'USD 5M – 10M',
            },
            {
              value: 'USD 10M – 25M',
              label: 'USD 10M – 25M',
            },
            {
              value: 'USD 25M +',
              label: 'USD 25M +',
            },
          ],
          size: 50,
          required: true,
        },
        phone: {
          id: 'phone',
          name: 'phone',
          type: 'text',
          label: 'Phone',
          autocomplete: 'phone',
          size: 100,
          required: true,
        },
        company: {
          id: 'company',
          name: 'company',
          type: 'text',
          label: 'Company',
          autocomplete: 'org',
          size: 100,
        },
        message: {
          id: 'message',
          name: 'message',
          type: 'textarea',
          label: 'Message',
          cols: 30,
          rows: 4,
          size: 50,
        },
        website: {
          id: 'website',
          name: 'website',
          type: 'text',
          label: 'Website',
          size: 50,
          required: true,
        },
        pitchdeck: {
          id: 'pitchdeck',
          name: 'pitchdeck',
          type: 'text',
          label: 'Link to Pitchdeck',
          size: 50,
          required: false,
        },
        privacy: {
          id: 'privacy',
          name: 'privacy',
          type: 'checkbox',
          choices: [{
            id: 'privacy',
            value: 'privacy',
            label: 'I agree to the <a href="/assets/pdf/moonshot_privacy-policy.pdf" target="_blank"><bdi>privacy policy</bdi></a>',
          }],
          required: true,
        },
        submit: {
          id: 'submit',
          name: 'submit',
          type: 'submit',
          text: 'Contact us',
          sending: 'Sending',
          sent: 'Sent',
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 50px;
  left: 20px;
  padding: 40px 60px;
  width: calc(100vw - 40px);
  height: calc(100vh - 70px);

  background-image: linear-gradient(-90deg, #261E3C 0%, #9F7B8A 100%);
  overflow: hidden;
  z-index: 50;

  @include mq(ipadP) {
    width: 850px;
    height: unset;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  &__close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 15px 18px;

    font-weight: 300;

    cursor: pointer;
  }

  &__title {
    margin-bottom: 40px;

    &::v-deep p {
      font-size: 24px;
    }
  }
}

.contact-form::v-deep {
  @include mq($until: ipadP) {
    height: 73vh;
    overflow: scroll;
  }

  .form__row {
    padding: 0 0 20px 0;

    @include mq($until: ipadP) {
      &:last-child {
        padding-bottom: 60px;
      }

      .form__group:first-child {
        margin-bottom: 20px;
      }
    }

    @include mq(ipadP) {
      .form__group:first-child,
      .form__row .form__group {
        justify-content: flex-start;
      }
    }

    .form__input--checkbox {
      max-width: unset;
    }

    .c-select__list {
      width: calc(100% + 24px);
      left: -12px;
      top: calc(100% + 10px);
    }

    .form__input--submit {
      background-color: $color-white;
      text-transform: uppercase;

      .form__input__text {
        font-family: $font-family-text;
        font-weight: 500;
        font-size: 10px;
        color: $color-black;
        letter-spacing: 3px;
      }
    }

    &.row--triple {
      align-items: flex-start;

      > div:not(.form__group) {
        flex: 0 0 100%;
        max-width: 100%;

        @include mq(ipadP) {
          flex: 0 0 calc(50% - (30px / 2));
          max-width: calc(50% - (30px / 2));
        }
      }

      .form__row {
        & > :first-child {
          margin-bottom: 20px;
        }
      }
    }
  }

  .form__group {
    font-size: 14px;

    &:not(.form__group--textarea) {
      min-height: unset;
    }
  }

  .form__input {
    // font-size: 18px;
    padding: 10px;
    // line-height: 32px;
  }

  input#privacy {
    display: none;
  }

  .form__group--submit {
    background-color: transparent;

    .form__input__text {
      padding: 20px;
      color: $color-white;
      font-family: $font-family-heading;
      text-align: center;
    }

    .form__input__line {
      display: none;
    }

    .form__input--submit {
      padding: 0;
    }
  }

  input,
  textarea {
    background-color: transparent;
    font-family: $font-family-text;
  }
}
</style>
